import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import { getUrl } from '~/services/shop/utils';

type Args = {
    users: ShopTypes.UserDto;
    token: string | null;
};

export default function addUser({ users, token }: Args) {
    return shop
        .post(getUrl('/customers/users'), {
            json: users,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .json<ShopTypes.UserDto>();
}
